import ZoneSetupList from './ZoneSetupList';

export default ZoneSetupList;
